import { selectPromoInventory } from './selectPromoInventory';
import { IApplicationState } from '../../types/redux';

export function selectIsForceClosedBanner(state: IApplicationState) {
  const promoInventory = selectPromoInventory(state);

  return promoInventory.isForceClosedBanner;
}
